import React, { useState } from 'react';
import Layout from '../Components/Layout';
import { Box, Typography, Grid, Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { FONT_FAMILY } from '../Constant';
import ShopifySetup from './ecommerce/ShopifySetup';
import { useSelector, useDispatch } from 'react-redux';
import { getWidgetColor } from '../redux/actions/widgetActions';
import { WIDGET_URL } from '../Config';
import useCallOnce from '../hooks/useCallOnce';
// import MagentoSetup from './ecommerce/MagentoSetup';
// import CustomSetup from './ecommerce/CustomSetup';
const token = localStorage.getItem('token');
function EcommerceSetup() {
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch();
  const { isConnected, stores, raw } = useSelector((s) => s.shopify);
  const { widgetColor: reduxWidgetColor } = useSelector((s) => s.widget);
  
  // Use widget color from API or fallback to defaul
  const widgetColor = reduxWidgetColor || '#d67900';


  // Extract dynamic values from the getUserDataWithStores API response stored in Shopify state
  // Based on the API response structure: data.user.agentId and data.user.storeUrl
  // Fallback to stores array if raw data is not available
  const agentId = raw?.data?.user?.agentId || ''; // fallback to default if not available
  const domain = stores?.[0]?.storeUrl || ''; // get storeUrl from user object in Shopify API response, fallback to stores array
  const accessToken = raw?.data?.shopifyStores?.[0]?.accessToken || stores?.[0]?.accessToken || ''; // get accessToken from shopifyStores[0]
  const themeId = raw?.data?.themeDetail?.[0]?.theme?.id || 'themeID';
  // const themeName = raw?.data?.themeDetail?.[0]?.theme?.name  || 'themeName';
  const appEmbedId = '76d2239ce16104dce1858d2a700b90a5'; //static appEmbedId

  // Load widget color on component mount using useCallOnce
  useCallOnce('ecommerce/getWidgetColor', () => {
    dispatch(getWidgetColor());
  });

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(`<script src="${WIDGET_URL}/chat-widget-bundled.js"></script>
<script>
    document.addEventListener('DOMContentLoaded', function() {
        new ChatWidget('body', {
            agentId: '${agentId}',
            domain: "${domain}",
            accessToken: "${accessToken}",
            themeColor: '${widgetColor}'
        });
    });
</script>`);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  const handleInstallClick = () => {
    if (domain) {
      // Extract store name from domain (remove .myshopify.com)
      const storeName = domain.replace('.myshopify.com', '');
      const shopifyAdminUrl = `https://admin.shopify.com/store/${storeName}/themes/${themeId}/editor?context=apps&appEmbed=${appEmbedId}&token=${token}`;
      console.log(shopifyAdminUrl);
      window.open(shopifyAdminUrl, '_blank');
    }
  };

  return (
    <Layout>
      <Box sx={{ fontFamily: FONT_FAMILY }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>Ecommerce Setup</Typography>
        <Typography variant="body2" sx={{ mb: 3, color: '#6b7280' }}>
          Connect your online store to Manage Agent.
        </Typography>

        <Box sx={{ background: '#fafafa', border: '1px solid #e5e7eb', borderRadius: 2, p: { xs: 2, md: 3 } }}>
          {/* <Typography sx={{ fontWeight: 600, mb: 2 }}>Select Ecommerce Store</Typography> */}
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, lg: 6 }}>
              <ShopifySetup />
            </Grid>
            {/* <Grid size={{ xs: 12, md: 6 }}>
              <MagentoSetup />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <CustomSetup />
            </Grid> */}
          </Grid>
        </Box>

        {/* Installation Method Section - Only show when Shopify is connected */}
        {isConnected && (
          <>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, mt: 3, }}>
            Installation Method
          </Typography>
            
          <Box sx={{ 
            background: '#fafafa', 
            border: '1px solid #e5e7eb', 
            borderRadius: 2, 
            p: { xs: 2, md: 3 } }}
          >
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, lg: 6 }}>
              <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: { xs: 2, sm: 0 }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    <CheckCircleIcon sx={{ 
                      fontSize: 32, 
                      color: '#10b981' 
                    }} />
                    <Box>
                      <Typography variant="subtitle1" sx={{ 
                        fontWeight: 600, 
                        color: '#111827',
                        fontSize: { xs: '1rem', sm: '1.125rem' }
                      }}>
                        Quick Installation for Shopify
                      </Typography>
                      <Typography variant="body2" sx={{ 
                        color: '#6b7280',
                        fontSize: { xs: '13px', sm: '14px' }
                      }}>
                        To add Chat, click Install then Save in the new Shopify window without editing anything.
                      </Typography>
                    </Box>
                  </Box>
                  
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleInstallClick}
                    disabled={!domain}
                    sx={{ 
                      background: copied ? '#333333' : '#000000',
                      color: '#ffffff',
                      border: copied ? 'none' : '1px solid #000000',
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 500,
                      minWidth: '100px',
                      px: 2,
                      py: 1,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      '&:hover': { 
                        background: copied ? '#000000' : '#333333',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                      },
                      '& .MuiButton-startIcon': {
                        color: '#ffffff'
                      },
                      '&.Mui-disabled': {
                        color: '#ffffff',
                        backgroundColor: '#333333'
                      }
                    }}
                  >
                    {raw?.data?.shopifyStores?.[0]?.is_connected_to_brand ? 
                    'Uninstall' : 'Install'}

                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
          
          {/* <Box sx={{ mt: 3, background: '#fafafa', border: '1px solid #e5e7eb', borderRadius: 2, p: { xs: 2, md: 3 } }}> */}
            {/* <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Installation Method
            </Typography>
            
            <Typography variant="body2" sx={{ mb: 2, color: '#6b7280' }}>
              Add the chat widget to your store by following the instructions below.
            </Typography> */}

            {/* <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
              Manual Installation
            </Typography> */}
            
            {/* Widget Color Display */}
            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Typography variant="body2" sx={{ color: '#6b7280' }}>
                Widget Color:
              </Typography>
              {widgetColorLoading ? (
                <CircularProgress size={16} sx={{ color: '#6b7280' }} />
              ) : (
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 1 
                }}>
                  <Box sx={{ 
                    width: 20, 
                    height: 20, 
                    borderRadius: '50%',
                    backgroundColor: widgetColor,
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                  }} />
                  <Typography variant="body2" sx={{ 
                    color: '#6b7280', 
                    fontFamily: 'monospace',
                    fontSize: '12px'
                  }}>
                    {widgetColor}
                  </Typography>
                </Box>
              )}
            </Box> */}
            
            {/* <Typography variant="body2" sx={{ mb: 2, color: '#6b7280' }}>
              Follow these steps to install the chat widget on your Shopify store:
            </Typography> */}

            {/* <Box component="ol" sx={{ pl: 3, mb: 3 }}>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#6b7280' }}>
                Go to your store's admin panel and search for <strong>Themes</strong>
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#6b7280' }}>
                Click the <strong>three-dot menu</strong> next to Customize, then click <strong>Edit code</strong>
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#6b7280' }}>
                Open file <strong>theme.liquid</strong>, scroll down to the bottom and find the <code>&lt;/body&gt;</code> tag
              </Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#6b7280' }}>
                Paste the code below directly above the <code>&lt;/body&gt;</code> tag
              </Typography>
            </Box> */}

            {/* Dynamic Script Display */}
            {/* <Box sx={{ 
              background: '#f5f5f5', 
              border: '1px solid #e0e0e0', 
              borderRadius: 1, 
              p: 2, 
              mb: 2,
              fontFamily: 'monospace',
              fontSize: '12px',
              overflow: 'auto'
            }}>
                  <Box component="pre" sx={{ margin: 0, whiteSpace: 'pre-wrap' }}>
{`<script src="${WIDGET_URL}/chat-widget-bundled.js"></script>
<script>
    document.addEventListener('DOMContentLoaded', function() {
        new ChatWidget('body', {
            agentId: '${agentId}',
            domain: "${domain}",
            accessToken: "${accessToken}",
            themeColor: '${widgetColor}'
        });
    });
</script>`}
              </Box>
            </Box> */}

            {/* <Box sx={{ 
              background: '#e8f5e8', 
              border: '1px solid #4caf50', 
              borderRadius: 1, 
              p: 2, 
              mb: 2 
            }}>
              <Typography variant="body2" sx={{ color: '#2e7d32', fontSize: '14px', mb: 1 }}>
                <strong>Current Configuration:</strong>
              </Typography>
              <Typography variant="body2" sx={{ color: '#2e7d32', fontSize: '12px', fontFamily: 'monospace' }}>
                agentId: {agentId}
              </Typography>
              <Typography variant="body2" sx={{ color: '#2e7d32', fontSize: '12px', fontFamily: 'monospace' }}>
                domain: {domain || 'Not set'}
              </Typography>
            </Box> */}

            {/* <Button 
              variant="outlined"
              startIcon={<ContentCopyIcon />}
              size="small"
              sx={{ 
                background: copied ? '#333333' : '#000000',
                color: '#ffffff',
                border: copied ? 'none' : '1px solid #000000',
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                minWidth: '100px',
                px: 2,
                py: 1,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                '&:hover': { 
                  background: copied ? '#000000' : '#333333',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                },
                '& .MuiButton-startIcon': {
                  color: '#ffffff'
                },
                '&.Mui-disabled': {
                  color: '#ffffff',
                  backgroundColor: '#333333'
                }
              }}
              onClick={handleCopyCode}
              disabled={copied}
            >
              {copied ? 'Copied!' : 'Copy Code'}
            </Button>

            <Box sx={{ 
              mt: 2, 
              p: 2, 
              border: '2px solid #ff9800', 
              borderRadius: 1, 
              background: '#fff3e0' 
            }}>
              <Typography variant="body2" sx={{ color: '#e65100', fontSize: '14px' }}>
                <strong>Important Note:</strong> Please note that by copying the code to your Shopify <strong>theme.liquid</strong> files, the chat will also be shown on all webpages. Make sure to copy the code to just specific pages if needed.
              </Typography>
            </Box> */}
          {/* </Box> */}
          </>
        )}
      </Box>
    </Layout>
  );
}

export default EcommerceSetup;
